import type {I18nKey} from "@zaaaz/shared";

export type HomeDepartmentStatus = "active" | "coming_soon";

export type HomeDepartmentConfig = {
  id: string;
  nameKey: I18nKey;
  descriptionKey: I18nKey;
  status: HomeDepartmentStatus;
  hubPath?: string;
  cardBg: string;
  cardImage: string;
};

export const BEAUTY_DEPARTMENT_ID = "beauty";

export const HOME_DEPARTMENTS: HomeDepartmentConfig[] = [
  {
    id: BEAUTY_DEPARTMENT_ID,
    nameKey: "Home department beauty title",
    descriptionKey: "Home department beauty card description",
    status: "active",
    hubPath: "/departments/beauty",
    cardBg: "#f3e8ff",
    cardImage: "/images/departments/beauty.png"
  },
  {
    id: "fashion",
    nameKey: "Home department fashion title",
    descriptionKey: "Home department fashion card description",
    status: "coming_soon",
    cardBg: "#e8eaf6",
    cardImage: "/images/departments/fashion.png"
  },
  {
    id: "home",
    nameKey: "Home department home title",
    descriptionKey: "Home department home card description",
    status: "coming_soon",
    cardBg: "#efebe9",
    cardImage: "/images/departments/home.png"
  },
  {
    id: "electronics",
    nameKey: "Home department electronics title",
    descriptionKey: "Home department electronics card description",
    status: "coming_soon",
    cardBg: "#e3f2fd",
    cardImage: "/images/departments/electronics.png"
  },
  {
    id: "sports",
    nameKey: "Home department sports title",
    descriptionKey: "Home department sports card description",
    status: "coming_soon",
    cardBg: "#e8f5e9",
    cardImage: "/images/departments/sports.png"
  },
  {
    id: "food",
    nameKey: "Home department food title",
    descriptionKey: "Home department food card description",
    status: "coming_soon",
    cardBg: "#fff3e0",
    cardImage: "/images/departments/food.png"
  },
  {
    id: "baby",
    nameKey: "Home department baby title",
    descriptionKey: "Home department baby card description",
    status: "coming_soon",
    cardBg: "#fce4ec",
    cardImage: "/images/departments/baby.png"
  },
  {
    id: "pets",
    nameKey: "Home department pets title",
    descriptionKey: "Home department pets card description",
    status: "coming_soon",
    cardBg: "#fff8e1",
    cardImage: "/images/departments/pets.png"
  },
  {
    id: "office",
    nameKey: "Home department office title",
    descriptionKey: "Home department office card description",
    status: "coming_soon",
    cardBg: "#eceff1",
    cardImage: "/images/departments/office.png"
  },
  {
    id: "automotive",
    nameKey: "Home department automotive title",
    descriptionKey: "Home department automotive card description",
    status: "coming_soon",
    cardBg: "#eceff1",
    cardImage: "/images/departments/automotive.png"
  },
  {
    id: "garden",
    nameKey: "Home department garden title",
    descriptionKey: "Home department garden card description",
    status: "coming_soon",
    cardBg: "#f1f8e9",
    cardImage: "/images/departments/garden.png"
  }
];

export function getDepartmentById(id: string): HomeDepartmentConfig | undefined {
  return HOME_DEPARTMENTS.find((d) => d.id === id);
}
